import gql from 'graphql-tag';

export const DELETE_TRACKED_PROPERTY = gql`
    mutation deleteTrackedProperty($propertyId: String, $uprn: String) {
        deleteTrackedProperty(propertyId: $propertyId, uprn: $uprn)
    }
`;
